import React from 'react'
import { SliderPicker } from 'react-color'

function ColorPicker({pickedColor,onColorChange}) {
    const hnadleColorChange=(c)=>{
        console.log("color",c);
        
        onColorChange && onColorChange(c)
    }
  return (
    <SliderPicker 
        color={ pickedColor||"#fff" }
        onChangeComplete={hnadleColorChange}
        // onChange={hnadleColorChange}
    /> 
  )
}

export default ColorPicker